import * as React from 'react';

import { Col } from './generic/grid/col';
import { Row } from './generic/grid/row';
import TagCard from './TagCard';
import * as styles from './TagCard.style';

import type { Topic } from '../types';

interface Props {
  // The view these topics were loaded for. Taken from the caller rather than
  // from the current route, so the links match the topics on screen even while
  // another page is loading.
  viewHash: string;
  sectionId: number;
  topics: Topic[];
}

// A section page: its topics three to a row, as in the mockups.
const TopicsList = ({ viewHash, sectionId, topics }: Props): React.ReactElement | null => {
  if (topics.length === 0) {
    return null;
  }

  return (
    <Row className="kb-topic-list" style={styles.list}>
      {topics.map((topic) => (
        <Col key={`topic-${topic.id}`} xs={12} sm={6} md={4} lg={4}>
          <TagCard tag={topic} to={`/v/${viewHash}/c/${sectionId}/t/${topic.id}`} style={styles.topicCard} />
        </Col>
      ))}
    </Row>
  );
};

export default TopicsList;
